import _slicedToArray from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/pc123-gatsby/pc123-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { ACTION_NEXT, ACTIVE_SLIDE_COMPLETE, ACTIVE_SLIDE_ERROR, ACTIVE_SLIDE_LOADING, ACTIVE_SLIDE_PLAYING, cleanup, makeUseContext, SLIDE_STATUS_COMPLETE, SLIDE_STATUS_ERROR, SLIDE_STATUS_LOADING, SLIDE_STATUS_PLAYING, useEventCallback, useEvents, useLightboxState, useTimeouts } from "../../core/index.js";
import { defaultSlideshowProps } from "./Slideshow.js";
var SlideshowContext = React.createContext(null);
export var useSlideshow = makeUseContext("useSlideshow", "SlideshowContext", SlideshowContext);
export function SlideshowContextProvider(_ref) {
  var slides = _ref.slides,
      slideshow = _ref.slideshow,
      finite = _ref.carousel.finite,
      children = _ref.children;

  var _defaultSlideshowProp = _objectSpread(_objectSpread({}, defaultSlideshowProps), slideshow),
      autoplay = _defaultSlideshowProp.autoplay,
      delay = _defaultSlideshowProp.delay;

  var _React$useState = React.useState(autoplay),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      playing = _React$useState2[0],
      setPlaying = _React$useState2[1];

  var scheduler = React.useRef();
  var slideStatus = React.useRef();
  var currentIndex = useLightboxState().state.currentIndex;

  var _useTimeouts = useTimeouts(),
      setTimeout = _useTimeouts.setTimeout,
      clearTimeout = _useTimeouts.clearTimeout;

  var _useEvents = useEvents(),
      publish = _useEvents.publish,
      subscribe = _useEvents.subscribe;

  var disabled = slides.length === 0 || finite && currentIndex === slides.length - 1;
  var togglePlaying = React.useCallback(function () {
    setPlaying(function (prev) {
      return !prev;
    });
  }, []);
  var cancelScheduler = React.useCallback(function () {
    clearTimeout(scheduler.current);
    scheduler.current = undefined;
  }, [clearTimeout]);
  var scheduleNextSlide = useEventCallback(function () {
    cancelScheduler();

    if (!playing || disabled || slideStatus.current === SLIDE_STATUS_LOADING || slideStatus.current === SLIDE_STATUS_PLAYING) {
      return;
    }

    scheduler.current = setTimeout(function () {
      if (playing) {
        slideStatus.current = undefined;
        publish(ACTION_NEXT);
      }
    }, delay);
  });
  React.useEffect(scheduleNextSlide, [currentIndex, playing, scheduleNextSlide]);
  React.useEffect(function () {
    if (playing && disabled) {
      setPlaying(false);
    }
  }, [currentIndex, playing, disabled]);
  React.useEffect(function () {
    return cleanup(cancelScheduler, subscribe(ACTIVE_SLIDE_LOADING, function () {
      slideStatus.current = SLIDE_STATUS_LOADING;
      cancelScheduler();
    }), subscribe(ACTIVE_SLIDE_PLAYING, function () {
      slideStatus.current = SLIDE_STATUS_PLAYING;
      cancelScheduler();
    }), subscribe(ACTIVE_SLIDE_ERROR, function () {
      slideStatus.current = SLIDE_STATUS_ERROR;
      scheduleNextSlide();
    }), subscribe(ACTIVE_SLIDE_COMPLETE, function () {
      slideStatus.current = SLIDE_STATUS_COMPLETE;
      scheduleNextSlide();
    }));
  }, [subscribe, cancelScheduler, scheduleNextSlide]);
  var context = React.useMemo(function () {
    return {
      playing: playing,
      disabled: disabled,
      togglePlaying: togglePlaying
    };
  }, [playing, disabled, togglePlaying]);
  return React.createElement(SlideshowContext.Provider, {
    value: context
  }, children);
}